'use client';

import { useRef, useMemo, useCallback, useLayoutEffect, useEffect } from "react";
function useResizeObserver({
  forwardedRef,
  onResize
}) {
  const storedRef = useRef(null);
  const onResizeRef = useRef(null);
  onResizeRef.current = onResize;
  const observer = useMemo(() => {
    if (typeof ResizeObserver === "undefined") return null;
    return new ResizeObserver(() => {
      const el = storedRef.current;
      if (!el) return;
      setTimeout(() => {
        var _a;
        (_a = onResizeRef.current) == null ? void 0 : _a.call(onResizeRef, el);
      }, 0);
    });
  }, []);
  const ref = useCallback((el) => {
    storedRef.current = el;
    if (forwardedRef == null) return;
    if (typeof forwardedRef === "function") {
      forwardedRef(el);
    } else {
      forwardedRef.current = el;
    }
  }, []);
  useLayoutEffect(() => {
    var _a, _b;
    const el = storedRef.current;
    if (!el) return;
    observer == null ? void 0 : observer.observe(el);
    (_b = (_a = [...el.children]).forEach) == null ? void 0 : _b.call(_a, (c) => observer == null ? void 0 : observer.observe(c));
  });
  useEffect(() => {
    const cleanup = () => {
      observer == null ? void 0 : observer.disconnect();
    };
    return cleanup;
  }, []);
  return ref;
}
export {
  useResizeObserver
};
